import { useState, useEffect } from "react";
import api from "../lib/api";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Skeleton } from "../components/ui/skeleton";
import { LayoutGrid, Plus, Share2, BarChart3, Table2, Activity, Target } from "lucide-react";

const widgetIcons = { chart: BarChart3, scorecard: Target, table: Table2, heatmap: Activity, status: Activity };

export default function DashboardsPage() {
  const [dashboards, setDashboards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/dashboards").then((r) => { setDashboards(r.data); setLoading(false); }).catch(() => setLoading(false)); }, []);

  if (loading) return <div className="p-6"><Skeleton className="h-48 bg-white/5" /></div>;

  return (
    <div className="p-6 space-y-6" data-testid="dashboards-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-[26px] font-extrabold tracking-tight text-[#2D3142]">Dashboards</h1>
          <p className="text-[13px] mt-0.5" style={{ color: "#6B7280" }}>{dashboards.length} dashboards available</p>
        </div>
        <Button className="rounded-lg font-semibold text-sm border-0 text-[#2D3142]" style={{ background: "linear-gradient(135deg, #29B5E8 0%, #1B8FC2 100%)" }} data-testid="new-dashboard-button">
          <Plus className="w-4 h-4 mr-2" /> New Dashboard
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="dashboards-grid">
        {dashboards.map((d, i) => (
          <div key={d.dashboard_id} className="sf-card p-5 animate-fade-up" style={{ animationDelay: `${i * 80}ms` }} data-testid={`dashboard-card-${d.dashboard_id}`}>
            <div className="flex items-center justify-between mb-3">
              <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: "rgba(30,58,95,0.08)" }}>
                <LayoutGrid className="w-4 h-4" style={{ color: "#1E3A5F" }} />
              </div>
              <div className="flex items-center gap-1.5">
                {d.is_shared && <Badge className="text-[8px] border-0 rounded" style={{ background: "rgba(124,58,237,0.12)", color: "#7C3AED" }}>Shared</Badge>}
              </div>
            </div>
            <h3 className="text-[15px] font-bold text-[#2D3142] mb-1">{d.title}</h3>
            <p className="text-[11px] mb-4" style={{ color: "#6B7280" }}>{d.description}</p>
            <div className="flex flex-wrap gap-1.5 mb-3">
              {(d.widgets || []).map((w, wi) => {
                const WIcon = widgetIcons[w.type] || Activity;
                return <div key={wi} className="flex items-center gap-1 px-2 py-1 rounded" style={{ background: "rgba(45,49,66,0.03)" }}>
                  <WIcon className="w-2.5 h-2.5" style={{ color: "#6B7280" }} /><span className="text-[9px] font-mono" style={{ color: "#6B7280" }}>{w.title}</span>
                </div>;
              })}
            </div>
            <div className="flex items-center justify-between">
              <span className="text-[10px] font-mono" style={{ color: "#9CA3AF" }}>{d.created_at?.slice(0, 10)}</span>
              <span className="text-[10px]" style={{ color: "#9CA3AF" }}>{d.created_by?.split("@")[0]}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
